// CustomRoute.jsx
import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useSelector } from "react-redux";

export default function CustomRoute({ element: Element, layout: Layout, privado = false, footer }) {
  const logado = useSelector((state) => state.auth.logado);

  if (privado && !logado) {
    return <Navigate to="/" />;
  }

  const content = Layout ? (
    <Layout footer={footer}>
      <Element />
    </Layout>
  ) : (
    <Element />
  );

  return content;
}
